/* eslint-disable no-fallthrough */

import { TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@mui/lab';
import { List, ListItemButton, Stack, Typography } from '@mui/material';
import { Scrollbar } from 'app/components';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

const MapTransportFlightList = (props) => {
  const conditionItems = useSelector((state) => state.map.transportSelectedItem.conditions);
  const { renderEmpty } = props;

  const items = useMemo(() => {
    return conditionItems
      .filter((conditions) => conditions.type === 'message')
      .reduce((accumulator, currentValue) => {
        const guard_status = (currentValue.data.guard_status >>> 0).toString(2).padStart(9, '0');
        const guard_status_sum = ['dut1', 'dut2', 'dut3', 'dut4', 'dut5', 'dut6']
          .map((key) => currentValue.data[key])
          .filter((number) => number >= 0)
          .reduce((a, b) => a + b, 0);

        switch (currentValue.data.geofence_type) {
          case 3:
            if (accumulator[accumulator.length - 1] === undefined || accumulator[accumulator.length - 1].datetime_end) {
              return [
                ...accumulator,
                {
                  datetime: currentValue.datetime,
                  geofence: currentValue.data.geofence_name,
                  datetime_end: null,
                  datetime_loaded: null,
                  total_mileage: currentValue.data.total_mileage,
                  total_mileage_end: null,
                  drain: [
                    {
                      datetime: null,
                      datetime_end: null,
                      geofence: null,
                      parking_time: [],
                    },
                  ],
                },
              ];
            }

            return accumulator;
          case 1:
            if (accumulator[accumulator.length - 1] !== undefined && accumulator[accumulator.length - 1].datetime_end === null) {
              if (guard_status[2] !== '0') {
                if (accumulator[accumulator.length - 1].drain.length !== 0) {
                  accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].datetime = accumulator[
                    accumulator.length - 1
                  ].drain[accumulator[accumulator.length - 1].drain.length - 1].datetime
                    ? accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].datetime
                    : currentValue.datetime;
                  accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].geofence_name =
                    accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].geofence_name
                      ? accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].geofence_name
                      : currentValue.data.geofence_name;

                  return accumulator;
                }

                if (accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].datetime_end) {
                  accumulator[accumulator.length - 1].drain.push({
                    datetime: currentValue.datetime,
                    geofence: currentValue.data.geofence_name,
                    parking_time: [],
                  });

                  return accumulator;
                }
              }

              // Специальное намерение исключить разрыв конструкции switch.
            }
          default:
            if (accumulator[accumulator.length - 1] !== undefined && accumulator[accumulator.length - 1].datetime_end === null) {
              switch (guard_status[2]) {
                case '0':
                  if (guard_status_sum < 300) {
                    accumulator[accumulator.length - 1].datetime_end = currentValue.datetime;
                    accumulator[accumulator.length - 1].total_mileage_end = currentValue.data.total_mileage;
                  }

                  if (accumulator[accumulator.length - 1].datetime_loaded === null) {
                    accumulator[accumulator.length - 1].datetime_loaded = currentValue.datetime;
                  }

                  if (accumulator[accumulator.length - 1].drain.length !== 0) {
                    if (accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].datetime) {
                      accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].datetime_end =
                        currentValue.datetime;

                      return accumulator;
                    }

                    if (currentValue.data.parking_time !== 0) {
                      if (
                        accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time
                          .length !== 0
                      ) {
                        accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time[
                          accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time
                            .length - 1
                        ] = currentValue.data.parking_time;

                        return accumulator;
                      }

                      accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time.push(
                        currentValue.data.parking_time
                      );

                      return accumulator;
                    }

                    if (
                      accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time
                        .length !== 0
                    ) {
                      if (
                        accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time[
                          accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time
                            .length - 1
                        ] !== 0
                      ) {
                        accumulator[accumulator.length - 1].drain[accumulator[accumulator.length - 1].drain.length - 1].parking_time.push(
                          currentValue.data.parking_time
                        );
                      }
                    }
                  }
              }
            }

            return accumulator;
        }
      }, [])
      .reverse();
  }, [conditionItems]);

  const formatDuration = (diff) => {
    const humanize = [];

    moment.relativeTimeThreshold('h', 23);
    moment.relativeTimeThreshold('m', 59);

    if (~~(diff / 60) > 0) {
      if (~~(diff / 60) <= 1) {
        humanize.push(`1 ${moment.duration(1, 'hours').humanize()}`);
      } else {
        humanize.push(moment.duration(~~(diff / 60), 'hours').humanize());
      }
    }
    if (diff % 60 > 0) {
      if (diff % 60 <= 1) {
        humanize.push(`1 ${moment.duration(1, 'minutes').humanize()}`);
      } else {
        humanize.push(moment.duration(Math.max(diff % 60, 1), 'minutes').humanize());
      }
    }

    return humanize.join(' ');
  };

  if (items.length === 0) {
    return renderEmpty();
  }

  return (
    <Stack
      direction='column'
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        bgcolor: 'background.default',
        borderTop: '1px solid',
        borderColor: theme.palette.divider,
        '.MuiList-root': {
          padding: theme.spacing(2),
        },
        '.simplebar-container': {
          maxHeight: 'none',
        },
      })}>
      <Scrollbar>
        <List
          disablePadding
          sx={(theme) => ({
            padding: theme.spacing(2),
          })}>
          {items.map((value, index) => (
            <TimelineItem
              key={index}
              sx={(theme) => ({
                display: 'flex',
                width: '100%',
                minHeight: 'auto',
                WebkitBoxPack: 'start',
                position: 'relative',
                '&:before': {
                  display: 'none',
                },
                '&:first-of-type': {
                  '.MuiTimelineConnector-root': {
                    marginTop: '10px',
                  },
                  '.MuiTimelineDot-root': {
                    bgcolor: theme.palette.primary.main,
                  },
                },
                '&:last-of-type': {
                  '.MuiTimelineConnector-root': {
                    height: '13px',
                    marginBottom: theme.spacing(0),
                  },
                },
                '.MuiTimelineItemButton-root': {
                  padding: theme.spacing(0),
                  cursor: 'default',
                },
                '.MuiTimelineDot-root': {
                  position: 'absolute',
                  top: '8.5px',
                  left: '4px',
                  bgcolor: 'background.paper',
                  border: '5px solid',
                  borderColor: theme.palette.primary.main,
                  margin: theme.spacing(0),
                  boxShadow: 'none',
                  '&.MuiTimelineDot-filledPrimary': {
                    bgcolor: theme.palette.primary.main,
                  },
                },
                '.MuiTimelineConnector-root': {
                  height: '100%',
                  border: '1px dashed',
                  bgcolor: 'transparent',
                  marginBottom: '2px',
                  marginRight: '4px',
                  flexGrow: 'unset',
                  borderColor: theme.palette.primary.main,
                },
                '.MuiTimelineSeparator-root': {
                  width: '30px',
                  height: '100%',
                  flex: 'none',
                  position: 'relative',
                },
                '.MuiTimelineContent-root': {
                  padding: '0',
                },
              })}>
              <ListItemButton disableTouchRipple className='MuiTimelineItemButton-root'>
                <TimelineSeparator>
                  <TimelineDot />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                  <Stack direction='column'>
                    <Stack
                      direction='column'
                      sx={(theme) => ({
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '6px',
                        position: 'relative',
                        bgcolor: 'background.paper',
                        border: '1px solid',
                        borderColor: theme.palette.divider,
                        borderRadius: theme.shape.borderRadius,
                        padding: theme.spacing(2),
                        marginBottom: '8px',
                        '&:before': {
                          top: '16px',
                          width: '10px',
                          left: '-5px',
                          height: '10px',
                          zIndex: '0',
                          content: '""',
                          display: 'block',
                          position: 'absolute',
                          transform: 'translateY(-50%) rotate(45deg)',
                          bgcolor: 'background.paper',
                          borderLeft: '1px solid',
                          borderBottom: '1px solid',
                          borderColor: theme.palette.divider,
                        },
                        '.MuiTypography-root': {
                          fontSize: '12px',
                          lineHeight: '16px',
                        },
                      })}>
                      <Stack direction='row'>
                        {value.datetime_loaded && (
                          <Typography variant='h6'>
                            Начало рейса - {value.geofence} {moment(value.datetime).format('HH:mm')} -{' '}
                            {moment(value.datetime_loaded).format('HH:mm')} (
                            {formatDuration(moment(value.datetime_loaded).diff(value.datetime, 'minutes'))})
                          </Typography>
                        )}
                        {!value.datetime_loaded && (
                          <Typography variant='h6'>
                            Начало рейса - {value.geofence} {moment(value.datetime).format('HH:mm')} - в процессе
                          </Typography>
                        )}
                      </Stack>
                      {value.drain
                        .filter((drain) => drain.datetime)
                        .map((drain, key) => (
                          <Stack
                            key={key}
                            direction='column'
                            sx={(theme) => ({
                              '.MuiTypography-root:first-of-type': {
                                marginLeft: '20px',
                              },
                              '.MuiTypography-root:last-of-type': {
                                marginLeft: '20px',
                                color: theme.palette.primary.main,
                              },
                            })}>
                            <Typography variant='span'>
                              Время остановок в пути {formatDuration(drain.parking_time.reduce((a, b) => a + b) / 60)}
                            </Typography>
                            {drain.datetime_end && (
                              <Typography variant='span'>
                                Слив #{key + 1} - {drain.geofence} {moment(drain.datetime).format('HH:mm')} -{' '}
                                {moment(drain.datetime_end).format('HH:mm')} (
                                {formatDuration(moment(drain.datetime_end).diff(drain.datetime, 'minutes'))})
                              </Typography>
                            )}
                            {!drain.datetime_end && (
                              <Typography variant='span'>
                                Слив #{key + 1} - {drain.geofence} {moment(drain.datetime).format('HH:mm')} - в процессе
                              </Typography>
                            )}
                          </Stack>
                        ))}
                      <Stack direction='row'>
                        {value.datetime_end && (
                          <Typography variant='span'>
                            Рейс завершен в {moment(value.datetime_end).format('HH:mm')} (
                            {formatDuration(moment(value.datetime_end).diff(value.datetime, 'minutes'))}
                            ). Пробег составил {Math.round((value.total_mileage_end - value.total_mileage) / 1000).toLocaleString(
                              'ru'
                            )}{' '}
                            {config.conditions.total_mileage.unit}
                          </Typography>
                        )}
                        {!value.datetime_end && <Typography variant='span'>Рейс не окончен</Typography>}
                      </Stack>
                    </Stack>
                    {items[index + 1] && (
                      <Stack
                        direction='row'
                        justifyContent='center'
                        sx={(theme) => ({
                          padding: theme.spacing(0, 2),
                          marginBottom: '8px',
                          '.MuiTypography-root:last-of-type': {
                            color: 'text.secondary',
                          },
                        })}>
                        <Typography variant='span'>
                          Время простоя между рейсами {moment(items[index + 1].datetime_end).format('HH:mm')} -{' '}
                          {moment(value.datetime).format('HH:mm')} (
                          {formatDuration(moment(value.datetime).diff(items[index + 1].datetime_end, 'minutes'))})
                        </Typography>
                      </Stack>
                    )}
                  </Stack>
                </TimelineContent>
              </ListItemButton>
            </TimelineItem>
          ))}
        </List>
      </Scrollbar>
    </Stack>
  );
};

export default MapTransportFlightList;
